import "./config";
////config IndexedDB Begin/////////
export const DB_NAME = "myAppDB"; ///db_name
export const DB_VERSION = 1; ///version db

///// Danh sách store (bảng) cần tạo ánh xạ từ csdl
export const STORE_NAMES = {
    agri_alike_circulate: "agri_alike_circulate",
    agri_alike_tree: "agri_alike_tree",
    agri_form_circulate: "agri_form_circulate",
    agri_limit_circulate: "agri_limit_circulate",
    agri_type_tree: "agri_type_tree",
    rsdt_cate_business: "rsdt_cate_business",
    rsdt_cate_clan: "rsdt_cate_clan",
    rsdt_cate_component_household: "rsdt_cate_component_household",
    rsdt_cate_education: "rsdt_cate_education",
    rsdt_cate_evils: "rsdt_cate_evils",
    rsdt_cate_marriage: "rsdt_cate_marriage",
    rsdt_cate_military: "rsdt_cate_military",
    rsdt_cate_policy: "rsdt_cate_policy",
    rsdt_cate_position_farmer: "rsdt_cate_position_farmer",
    rsdt_cate_position_members: "rsdt_cate_position_members",
    rsdt_cate_position_women: "rsdt_cate_position_women",
    rsdt_cate_prevent: "rsdt_cate_prevent",
    rsdt_cate_reason: "rsdt_cate_reason",
    rsdt_cate_relationship: "rsdt_cate_relationship",
    rsdt_cate_status_household: "rsdt_cate_status_household",
    rsdt_cate_status_people: "rsdt_cate_status_people",
    rsdt_cate_targets_subsidize: "rsdt_cate_targets_subsidize",
    rsdt_dead_people: "rsdt_dead_people",
    rsdt_diary_business_household: "rsdt_diary_business_household",
    rsdt_diary_clan: "rsdt_diary_clan",
    rsdt_diary_culture_household: "rsdt_diary_culture_household",
    rsdt_diary_education: "rsdt_diary_education",
    rsdt_diary_evils: "rsdt_diary_evils",
    rsdt_diary_farmer: "rsdt_diary_farmer",
    rsdt_diary_health_insurance: "rsdt_diary_health_insurance",
    rsdt_diary_household: "rsdt_diary_household",
    rsdt_diary_job: "rsdt_diary_job",
    rsdt_diary_marriage: "rsdt_diary_marriage",
    rsdt_diary_merit_household: "rsdt_diary_merit_household",
    rsdt_diary_military: "rsdt_diary_military",
    rsdt_diary_personal: "rsdt_diary_personal",
    rsdt_diary_policy_household: "rsdt_diary_policy_household",
    rsdt_diary_register_culture_household: "rsdt_diary_register_culture_household",
    rsdt_diary_resident: "rsdt_diary_resident",
    rsdt_diary_social_insurance: "rsdt_diary_social_insurance",
    rsdt_diary_status_household: "rsdt_diary_status_household",
    rsdt_diary_staying: "rsdt_diary_staying",
    rsdt_diary_subsidize: "rsdt_diary_subsidize",
    rsdt_diary_union_members: "rsdt_diary_union_members",
    rsdt_diary_union_women: "rsdt_diary_union_women",
    rsdt_diary_vaccination: "rsdt_diary_vaccination",
    rsdt_household: "rsdt_household",
    rsdt_people: "rsdt_people",
    rsdt_type_achieve: "rsdt_type_achieve",
    tbl_cate_ethnic: "tbl_cate_ethnic",
    tbl_cate_forms_training: "tbl_cate_forms_training",
    tbl_cate_informatics_certificate: "tbl_cate_informatics_certificate",
    tbl_cate_language_certificate: "tbl_cate_language_certificate",
    tbl_cate_nationality: "tbl_cate_nationality",
    tbl_cate_organize: "tbl_cate_organize",
    tbl_cate_position_party: "tbl_cate_position_party",
    tbl_cate_position_trade_union: "tbl_cate_position_trade_union",
    tbl_cate_position_union: "tbl_cate_position_union",
    tbl_cate_religion: "tbl_cate_religion",
    tbl_diary_personal: "tbl_diary_personal",
    tbl_function_permission: "tbl_function_permission",
    tbl_menu: "tbl_menu",
    tbl_module_permission: "tbl_module_permission",
    tbl_organize: "tbl_organize",
    tbl_organize_info: "tbl_organize_info",
    tbl_product: "tbl_product",
    tbl_product_cate: "tbl_product_cate",
    tbl_role: "tbl_role",
    tbl_session_user: "tbl_session_user",
    tbl_staff: "tbl_staff",
    tbl_user: "tbl_user",
    tbl_work_day: "tbl_work_day",
    tbl_work_schedule: "tbl_work_schedule",
    tbl_work_task: "tbl_work_task",
    rsdt_tk_status_household: "rsdt_tk_status_household",
    rsdt_tk_by_age_people: "rsdt_tk_by_age_people",
    rsdt_tk_life_death_people: "rsdt_tk_life_death_people",
    rsdt_tk_union_members: "rsdt_tk_union_members",
    rsdt_tk_union_women: "rsdt_tk_union_women",
    rsdt_tk_farmer: "rsdt_tk_farmer",
    rsdt_tk_marriage: "rsdt_tk_marriage",
    rsdt_tk_clan: "rsdt_tk_clan",
    rsdt_tk_evils: "rsdt_tk_evils",
    rsdt_tk_military: "rsdt_tk_military",
    rsdt_tk_education: "rsdt_tk_education",
    rsdt_tk_culture_household: "rsdt_tk_culture_household",
    my_function_permission: "my_function_permission",
    dashboards: "dashboards",
    sync_tracking: "sync_tracking", /////theo doi dong bo
};

window.DB_NAME = DB_NAME;
window.DB_VERSION = DB_VERSION;
window.STORE_NAMES = STORE_NAMES;
////////////////config IndexedDB End////////////
